import { ProjectDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadProjectManagement = createAction(
  '[ProjectManagement] Load ProjectManagement'
);

export const loadProjectManagementSuccess = createAction(
  '[ProjectManagement] Load ProjectManagement Success',
  props<{ projectManagement: ProjectDto[] }>()
);

export const loadProjectManagementFailure = createAction(
  '[ProjectManagement] Load ProjectManagement Failure',
  props<{ error: any }>()
);

/**
 * Add Project to Collection Actions
 */
export const addProjectManagement = createAction(
  '[ProjectManagement] Add ProjectManagement',
  props<{ newProjectManagement: ProjectDto }>()
);

export const addProjectManagementSuccess = createAction(
  '[ProjectManagement] Add ProjectManagement Success',
  props<{ newProjectManagement: ProjectDto }>()
);

export const addProjectManagementFailure = createAction(
  '[ProjectManagement] Add ProjectManagement Failure',
  props<{ error: any }>()
);

/**
 * Add Project Sub to Collection Actions
 */
export const addProjectSubManagement = createAction(
  '[ProjectManagement] Add Sub ProjectManagement',
  props<{ newProjectSubManagement: ProjectDto }>()
);

export const addProjectSubManagementSuccess = createAction(
  '[ProjectManagement] Add Sub ProjectManagement Success',
  props<{ newProjectSubManagement: ProjectDto }>()
);

export const addProjectSubManagementFailure = createAction(
  '[ProjectManagement] Add Sub ProjectManagement Failure',
  props<{ error: any }>()
);

/**
 * Upload Project-record to Collection Actions
 */
export const uploadExcelStudentRecord = createAction(
  '[ProjectManagement] Upload Excel ProjectManagement',
  props<{ uploadExcelRecord: ProjectDto[] }>()
);

export const uploadExcelStudentRecordSuccess = createAction(
  '[Student-record] Upload Excel ProjectManagement Success',
  props<{ uploadExcelRecord: ProjectDto[] }>()
);

export const uploadExcelStudentRecordFailure = createAction(
  '[Student-record] Upload Excel ProjectManagement Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchProjectManagementRecord = createAction(
  '[ProjectManagement] Search  ProjectManagement Record',
  props<{ query: string }>()
);

/**
 * Update ProjectManagement Collection Actions
 */
export const updateProjectManagement = createAction(
  '[ProjectManagement] Update ProjectManagement',
  props<{ updateProjectManagement: ProjectDto }>()
);

export const updateProjectManagementSuccess = createAction(
  '[ProjectManagement] Update ProjectManagement Success',
  props<{ updateProjectManagement: ProjectDto }>()
);

export const updateProjectManagementFailure = createAction(
  '[ProjectManagement] Update ProjectManagement Failure',
  props<{ error: any }>()
);

/**
 * Remove ProjectManagement Collection Actions
 */
export const removeProjectManagement = createAction(
  '[ProjectManagement] Remove ProjectManagement',
  props<{ ids: any[] }>()
);

export const removeProjectManagementSuccess = createAction(
  '[ProjectManagement] Remove ProjectManagement Success',
  props<{ ids: any[] }>()
);

export const removeProjectManagementFailure = createAction(
  '[ProjectManagement] Remove ProjectManagement Failure',
  props<{ error: any }>()
);

/**
 * Remove Project Stakeholder Collection Actions
 */
export const removeProjectManagementStakeholder = createAction(
  '[ProjectManagement] Remove ProjectManagement Stakeholder',
  props<{ ids: any[] }>()
);

export const removeProjectManagementStakeholderSuccess = createAction(
  '[ProjectManagement] Remove ProjectManagement Stakeholder Success ',
  props<{ ids: any[] }>()
);

export const removeProjectManagementStakeholderFailure = createAction(
  '[ProjectManagement] Remove ProjectManagement Stakeholder Failure',
  props<{ error: any }>()
);

/**
 * Remove Project Cluster Collection Actions
 */
export const removeProjectManagementCluster = createAction(
  '[ProjectManagement] Remove ProjectManagement Cluster',
  props<{ ids: any[] }>()
);

export const removeProjectManagementClusterSuccess = createAction(
  '[ProjectManagement] Remove ProjectManagement Cluster Success ',
  props<{ ids: any[] }>()
);

export const removeProjectManagementClusterFailure = createAction(
  '[ProjectManagement] Remove ProjectManagement Cluster Failure',
  props<{ error: any }>()
);

/**
 * Remove Project Report Master Collection Actions
 */
export const removeProjectManagementReportMaster = createAction(
  '[ProjectManagement] Remove ProjectManagement Report Master',
  props<{ ids: any[] }>()
);

export const removeProjectManagementReportMasterSuccess = createAction(
  '[ProjectManagement] Remove ProjectManagement Report Master Success ',
  props<{ ids: any[] }>()
);

export const removeProjectManagementReportMasterFailure = createAction(
  '[ProjectManagement] Remove ProjectManagement Report Master Failure',
  props<{ error: any }>()
);

/**
 * Remove Project Report Master Collection Actions
 */
export const removeProjectManagementReportMeeting = createAction(
  '[ProjectManagement] Remove ProjectManagement Report Meeting',
  props<{ ids: any[] }>()
);

export const removeProjectManagementReportMeetingSuccess = createAction(
  '[ProjectManagement] Remove ProjectManagement Report Meeting Success ',
  props<{ ids: any[] }>()
);

export const removeProjectManagementReportMeetingFailure = createAction(
  '[ProjectManagement] Remove ProjectManagement Report Meeting Failure',
  props<{ error: any }>()
);

/**
 * Remove Project Report Master Collection Actions
 */
export const removeProjectManagementMain = createAction(
  '[ProjectManagement] Remove ProjectManagement Main',
  props<{ id: string }>()
);

export const removeProjectManagementMainSuccess = createAction(
  '[ProjectManagement] Remove ProjectManagement Main Success ',
  props<{ id: string }>()
);

export const removeProjectManagementMainFailure = createAction(
  '[ProjectManagement] Remove ProjectManagement Main Failure',
  props<{ error: any }>()
);
